 const keys = {

   // set REACT_APP_API_SERVER in .env.development for local dev (see .env.development)
   server: process.env.REACT_APP_API_SERVER || "/api"


}

export default keys
